import Link from 'next/link';
import { useRouter } from 'next/router';
import { useContext, useEffect } from 'react';

import MapCordinateContext from '@/context/MapCordinateContext';
import { capitalizeFirstLetterOfWords } from '@/helper/wordReplace';

const Breadcrumb = (props: any) => {
  const { facilityData } = props;
  const { query, locale, asPath }: any = useRouter();
  const getCity = query && query.location && query.location[0];
  const getStore =
    query && query.location && query.location[1]
      ? facilityData?.attributes?.Title
      : null;
  const cityName = capitalizeFirstLetterOfWords(getCity);
  const cityStore = capitalizeFirstLetterOfWords(getStore);
  const citySlug = facilityData?.attributes?.City_Slug;
  const cords = useContext(MapCordinateContext);

  useEffect(() => {
    const switchLocale = JSON.parse(sessionStorage.getItem('switchLocale'));
    const currentUrl = {
      path: asPath,
      locale,
      domain: process.env.NEXT_PUBLIC_SITE_URL_ORIGIN,
      switchLocale,
    };
    const preRoute = JSON.parse(sessionStorage.getItem('preRoute'));
    const getPreRoute = JSON.parse(sessionStorage.getItem('prevRoute'));
    const getUpdateRoute = JSON.parse(sessionStorage.getItem('updateRou'));
    if (
      getPreRoute &&
      getPreRoute.locale === locale &&
      (preRoute !== getUpdateRoute || (!preRoute && !getUpdateRoute))
    ) {
      sessionStorage.setItem('preRoute', JSON.stringify(currentUrl));
      sessionStorage.setItem('switchLocale', JSON.stringify(locale));
    } else if (preRoute && locale !== switchLocale) {
      sessionStorage.setItem('updateRou', JSON.stringify(currentUrl));
      sessionStorage.setItem('prevRoute', null);
    } else if (getUpdateRoute && preRoute && preRoute !== getUpdateRoute) {
      sessionStorage.setItem('prevRoute', null);
    } else if (!preRoute && !getUpdateRoute && !getPreRoute) {
      sessionStorage.setItem('preRoute', JSON.stringify(currentUrl));
      sessionStorage.setItem('switchLocale', JSON.stringify(locale));
    }
  }, [facilityData]);

  const handleClick = () => {
    cords.setLatLog({});
    cords.setLatLogCity({});
  };

  return (
    <section className="sv-breadcrumb-revamp">
      <nav aria-label="breadcrumb" className="d-flex mb-2">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link href="/" prefetch={false}>
              {locale === 'en' ? 'Home' : 'Accueil'}
            </Link>
          </li>
          <li className="breadcrumb-separator"></li>
          <li className="breadcrumb-item">
            <Link
              href={
                locale === 'en'
                  ? '/en/self-storage'
                  : '/entreposage-libre-service'
              }
            >
              <a onClick={handleClick}>
                {locale === 'en' ? 'Locations' : 'Succursales'}
              </a>
            </Link>
          </li>
          {query?.location[0] && query?.location[1] && !citySlug ? (
            <>
              <li className="breadcrumb-separator"></li>
              <li className="breadcrumb-item">
                <Link
                  href={`${
                    locale === 'en'
                      ? '/en/self-storage'
                      : '/entreposage-libre-service'
                  }/${query?.location[0]}`}
                  as={`${
                    locale === 'en'
                      ? '/en/self-storage'
                      : '/entreposage-libre-service'
                  }/${query?.location[0]}`}
                >
                  <a>{cityName}</a>
                </Link>
              </li>
            </>
          ) : (
            <>
              <li className="breadcrumb-separator"></li>
              <li className="breadcrumb-item active">{cityName}</li>
            </>
          )}
          {cityStore && (
            <>
              <li className="breadcrumb-separator"></li>
              <li className="breadcrumb-item active" aria-current="page">
                {cityStore}
              </li>
            </>
          )}
        </ol>
      </nav>
    </section>
  );
};

export default Breadcrumb;
